import { useEffect, useState } from "react";
import axios from "axios";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      console.log("Fetching blogs...");
      const response = await axios.get("https://2uat7oq4p3xmd6xxksawogib5a0fbsbx.lambda-url.us-east-1.on.aws/get-all-blogs");
      console.log("API Response:", response);
  
      // Extract the blogs array correctly
      if (Array.isArray(response.data.blogs)) {
        setBlogs(response.data.blogs);
      } else {
        console.error("Unexpected response format:", response.data);
        setBlogs([]); // Fallback to an empty array
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setBlogs([]); // Ensure blogs is always an array
    }
  };      

  const handleDelete = async (blog_id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    try {
      await axios.delete(`https://m4azsmdx7fssqiougdacfvjul40ponmb.lambda-url.us-east-1.on.aws/delete-blog/${blog_id}`);
      setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog.blog_id !== blog_id));
      alert("Blog deleted successfully!");
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  console.log(blogs)

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Blog List</h1>
      <button
        onClick={() => navigate("/")}
        className="mt-8 bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition"
      >Back to Dashboard</button>
      {Array.isArray(blogs) && blogs.length > 0 ? (
            <ul className="space-y-4">
                {blogs.map((blog) => (
                <li key={blog.blog_id} className="p-4 border rounded flex justify-between items-center">
                    <span>{blog.title}</span>
                    <button onClick={() => handleDelete(blog.blog_id)} className="p-2 bg-red-500 text-white rounded">
                    <Trash2 size={20} />
                    </button>
                </li>
                ))}
            </ul>
            ) : (
            <p>No blogs available. Count: {blogs.length}</p>
            )}
    </div>
  );
}
